import { getRuleById } from '../../../../../services/studentAttendance/rulesSetting';
import { timeArr } from '../../../../../utils/studentAttendance';

const initState = {
  checkNewRulePush: {
    parentPushStatus: '1', // 家长推送状态，1表示开启，0表示关闭
    parentPushRuleStatus: '0',
    parentEspeciallyPushRuleStatus: '0',
    parentEspeciallyInPushRuleList: [],
    parentEspeciallyOutPushRuleList: [],
    parentPushRuleList: [],
    schoolAbnormalPushStatus: '1',
    classAbnormalPushStatus: '1',
    gradeAbnormalPushStatus: '1',
    schoolAbnormalPushSelectId: '', // 汇总安全报告推送其他人的选人组件id
  },
};

export default {
  namespace: 'pushSetting',
  state: initState,
  effects: {
    *fetchRuleById({ params }, { call, put }) {
      try {
        const response = yield call(getRuleById, params);
        const { checkNewRulePush } = response;
        yield put({
          type: 'saveState',
          payload: {
            checkNewRulePush: {
              parentPushStatus: checkNewRulePush.parentPushStatus || '1', // 家长推送状态，1表示开启，0表示关闭
              parentPushRuleStatus: checkNewRulePush.parentPushRuleStatus || '0',
              parentPushRuleList: timeArr(checkNewRulePush.parentPushRuleList) || [],
              parentEspeciallyPushRuleStatus:
                checkNewRulePush.parentEspeciallyPushRuleStatus || '0',
              parentEspeciallyInPushRuleList:
                timeArr(checkNewRulePush.parentEspeciallyInPushRuleList) || [],
              parentEspeciallyOutPushRuleList:
                timeArr(checkNewRulePush.parentEspeciallyOutPushRuleList) || [],
              schoolAbnormalPushStatus: checkNewRulePush.schoolAbnormalPushStatus || '1',
              classAbnormalPushStatus: checkNewRulePush.classAbnormalPushStatus || '1',
              gradeAbnormalPushStatus: checkNewRulePush.gradeAbnormalPushStatus || '1',
              schoolAbnormalPushSelectId: checkNewRulePush.schoolAbnormalPushSelectId || '',
            },
          },
        });
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject((error.data && error.data.msg) || '网络错误，请重试');
      }
    },
  },

  reducers: {
    saveState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return {
        ...initState,
      };
    },
  },
};
